import { renderCountryName, renderTreatingPhysicianList } from '../../util/names'

export default (isTablet) => {
    return isTablet ? columnListTablet : columnListDesktop
}

const columnListDesktop = [
    {
        property: 'clinicName',
        header: 'Clinic Name',
        columnName: 'store_store.clinicName',
    },
    {
        property: 'technicalName',
        header: 'Technical Name',
        columnName: 'store_store.technicalName',
    },
    {
        property: 'email',
        header: 'Email',
        columnName: 'store_store.email',
    },
    {
        property: 'isActive',
        header: 'Active',
        width: '80',
        columnName: 'store_store.isActive',
    },
    {
        property: 'city',
        header: 'City',
        columnName: 'store_store.city',
    },
    {
        property: 'countryCode',
        header: 'Country',
        renderer: (store) => {
            return renderCountryName(store.countryCode)
        },
        columnName: 'store_store.countryCode',
    },
    {
        property: 'isPartner',
        header: 'Partner',
        width: '100',
        columnName: 'store_store.isPartner',
    },
    {
        property: 'iprProvider',
        header: 'IPR',
        width: '50',
        columnName: 'store_store.iprProvider',
    },
    {
        property: 'scanFileUploadMechanism',
        header: 'Upload Mechanism',
        width: '120',
        columnName: 'store_store.scanFileUploadMechanism',
    },
    {
        property: 'partnerMgmtCategory',
        header: 'Partner Mgmt Cat',
        width: '120',
        columnName: 'store_store.partnerMgmtCategory',
    },
    {
        property: 'treatingPhysicians',
        header: 'TreatingPhysicianList',
        renderer: (store) => {
            return renderTreatingPhysicianList(store.treatingPhysicians)
        },
        columnName: 'treatingPhysicians',
    },
]

const columnListTablet = [
    {
        property: 'clinicName',
        header: 'Clinic Name',
        columnName: 'store_store.clinicName',
    },
    {
        property: 'technicalName',
        header: 'Technical Name',
        columnName: 'store_store.technicalName',
    },
    {
        property: 'email',
        header: 'Email',
        columnName: 'store_store.email',
    },
    {
        property: 'active',
        header: 'Active',
        width: '80',
        columnName: 'store_store.isActive',
    },
    {
        property: 'streetAddress',
        header: 'Address',
        columnName: 'store_store.streetAddress',
    },
    {
        property: 'city',
        header: 'City',
        columnName: 'store_store.city',
    },
    {
        property: 'zip',
        header: 'ZIP',
        width: '80',
        columnName: 'store_store.zip',
    },
    {
        property: 'countryCode',
        header: 'Country',
        renderer: (store) => {
            return renderCountryName(store.countryCode)
        },
        columnName: 'store_store.countryCode',
    },
    {
        property: 'isPartner',
        header: 'Partner',
        width: '100',
        columnName: 'store_store.isPartner',
    },
    {
        property: 'iprProvider',
        header: 'IPR',
        width: '50',
        columnName: 'store_store.iprProvider',
    },
    {
        property: 'scanFileUploadMechanism',
        header: 'Upload Type',
        width: '120',
        columnName: 'store_store.scanFileUploadMechanism',
    },
    {
        property: 'partnerMgmtCategory',
        header: 'Partner Mgmt',
        width: '120',
        columnName: 'store_store.partnerMgmtCategory',
    },
]



// WEBPACK FOOTER //
// ./src/modules/store/component/search/store-column-list.js